var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"licences-list"},_vm._l((_vm.licences),function(licence){return _c('div',{key:licence.id},[_c('FishingLicenceItem',{attrs:{"licence":licence},on:{"reload":function($event){return _vm.$emit('reload')}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }